import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import UsercardStat from '../components/UsercardStat';
export default function extendUserCard() {
  extend(UserCard.prototype, 'infoItems', function (items) {
    const user = this.attrs.user;
    items.add('discussion-count', m(UsercardStat, {
      icon: "fas fa-comment",
      displayText: app.translator.trans('fof-usercard-stats.forum.user.discussion-count', {
        count: user.discussionCount()
      })
    }), 70);
    items.add('comment-count', m(UsercardStat, {
      icon: "fas fa-comments",
      displayText: app.translator.trans('fof-usercard-stats.forum.user.post-count', {
        count: user.commentCount()
      })
    }), 65);
  });
}
flarum.reg.add('fof-usercard-stats', 'forum/extend/extendUserCard', extendUserCard);